import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchInitiatives } from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";

export default function InitiativesPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { fetchInitiatives().then(setItems).catch(() => {}); }, []);

  return (
    <div data-testid="page-initiatives" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <SectionHeader
        overline="Initiatives"
        title={<>Programmes <span className="italic text-ra-ochre">on the ground</span>.</>}
        lede="Three flagship initiatives currently delivering across Australia — backing Indigenous-led enterprise, market readiness, and practitioner capability."
        testId="initiatives-header"
      />

      <div className="mt-16 space-y-1 bg-ra-line border border-ra-line">
        {items.map((i, idx) => (
          <Link
            key={i.id}
            to={`/initiatives/${i.slug}`}
            data-testid={`initiative-card-${i.slug}`}
            className="block bg-ra-bone group hover:bg-ra-paper transition-colors duration-300"
          >
            <div className="p-8 lg:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-4">
                <div className="aspect-[4/3] overflow-hidden border border-ra-line">
                  <img src={i.image_url} alt={i.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale-[0.08]" />
                </div>
              </div>
              <div className="lg:col-span-7">
                <div className="ra-overline">Initiative 0{idx + 1}</div>
                <h3 className="ra-serif text-4xl lg:text-5xl mt-3 leading-[1.05]">{i.name}</h3>
                <p className="mt-3 italic text-ra-ochre text-lg">{i.tagline}</p>
                <p className="mt-5 text-ra-soft leading-relaxed max-w-2xl">{i.summary}</p>
              </div>
              <div className="lg:col-span-1 flex lg:justify-end">
                <ArrowRight size={32} className="text-ra-eucalypt transition-transform duration-500 group-hover:translate-x-2 group-hover:text-ra-ochre" strokeWidth={1.2} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
